import { JedinicaMere } from './jedinica-mere';
import { BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseContainerService } from 'yt-ng-framework';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-jedinica-mere-update',
  templateUrl: './jedinica-mere-update.component.html'
})
export class JedinicaMereUpdateComponent extends BaseUpdateComponent<JedinicaMere> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'JEDINICAMERE.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(200), 'maxlength', 'JEDINICAMERE.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Oznaka", Validators.required, 'required', 'JEDINICAMERE.OZNAKA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Oznaka", Validators.maxLength(50), 'maxlength', 'JEDINICAMERE.OZNAKA.VALIDATION.MAXLENGTH');
  }

}
